<template>
  <div class="ui-content dashboard">
    <v-card class="mx-auto normal-card">
      <div class="data-table-section notification-tb">
        <v-data-table
          :headers="headers"
          :items="items"
          hide-default-header
          hide-default-footer
          fixed-header
          class="elevation-2 cust-table"
          single-expand
        >
          <template v-slot:header="{ props: { headers } }">
            <TableHeader
              :headers="headers"
              :onHeaderAction="onHeaderAction"
              :orderBy="orderBy"
              :onSortChange="onSortChange"
            />
          </template>

          <template v-slot:item="{ item, expand, isExpanded }">
            <tr
              v-bind:class="[
                { 'border-none-td': isExpanded },
                { 'bold-row': addBoldClass(item) },
              ]"
            >
              <td class="text-center fix-101">{{ item.created_at }}</td>
              <td class="text-center fix-101">{{ getUserName(item) }}</td>
              <td class="text-center">{{ getUserRole(item) }}</td>
              <td class="max-550">
                <div
                  v-if="item.subject == 'New Question Assigned'"
                  class="message-block-upper"
                >
                  <div v-html="item.message"></div>
                </div>
                <div
                  v-else-if="item.subject != 'New Question Assigned'"
                  class="message-block-height"
                >
                  {{ extractContent(item.message) }}
                </div>
              </td>
              <td class="action-100" @click="expand(!isExpanded)">
                <div class="inbox-icon" v-if="isExpanded">
                  <v-icon class="minus-circle-1">mdi-minus-circle</v-icon>
                </div>
                <div
                  @click="updateReadStatus(item)"
                  class="inbox-icon"
                  v-if="!isExpanded"
                >
                  <v-icon>mdi-plus-circle</v-icon>
                </div>
              </td>
            </tr>
          </template>

          <template v-slot:expanded-item="{ item }">
            <tr
              class="sub-table-col"
              :key="ind"
              v-for="(sub, ind) in item.subitem"
            >
              <td></td>
              <td></td>
              <td></td>
              <td class="max-550">
                <div class="message-block" v-html="sub.message"></div>
              </td>
              <td class="action-100">
                <div class="inbox-repply">
                  <div class="inbox-icon">
                    <v-icon @click="ComposeMsgDialog(item)"
                      >mdi-reply-circle</v-icon
                    >
                  </div>
                  <div class="inbox-icon" @click="DeleteMSGDialog(item)">
                    <v-icon>mdi-delete-circle</v-icon>
                  </div>
                </div>
              </td>
            </tr>
          </template>
        </v-data-table>
      </div>
    </v-card>
    <div class="footer-btn">
      <div class="pull-left">
        <v-btn
          v-if="this.user.role_id !== this.roleIds.ST"
          class="right-btn cust-btn"
          color="primary"
          @click="ComposeMsgDialog()"
          >New Message</v-btn
        >
        <v-btn
          v-if="shouldShowBroadcastButton()"
          class="right-btn cust-btn"
          color="primary"
          @click="broadcastMsgComposeDialog()"
          >New Broadcast Message</v-btn
        >
      </div>
      <div class="pull-right">
        <Pagination
          :currentPage="currentPage"
          :totalPage="totalPages"
          :onPageChange="onPageChange"
        />
      </div>
    </div>
    <AlertBox
      :width="modalwidth"
      :onClose="onClose"
      :component="cComponent"
      :status="status"
      :showLoader="showRootLoader"
      :data="selectedUser"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import moment from "moment";
export default {
  name: "Notification",
  mounted() {
    this.checkSessionData();
  },
  data() {
    return {
      pathName: window.location.pathname,
      status: false,
      currentPage: 1,
      pageSize: 10,
      totalPages: 1,
      orderBy: {
        field: "created_at",
        order: "DESC",
      },
      modalwidth: null,
      cComponent: "components/coordinator/ComposeMsg",
      userTypes: [],
      items: [],
      selectedUsertypes: [],
      selectedUser: [],
    };
  },
  methods: {
    ...mapActions({
      getMessages: "messageStore/getMessages",
      deleteMessage: "messageStore/deleteMessage",
      updateNotificationReadStatus: "messageStore/updateNotificationReadStatus",
    }),
    defaultData() {
      let routeName = this.$route.name;
      let crd = this.getCurrentRouteDetails(routeName);
      if (crd) {
        this.currentPage = crd.tabDetails[crd.selectedTab].page;
        this.orderBy = crd.tabDetails[crd.selectedTab].orderBy;
        this.selectedUsertypes = crd.tabDetails[crd.selectedTab].userTypes; // load center ids from session
      }
      this.userTypes = this.getUserTypes();
      this.requestGetMessages();
    },
    checkSessionData() {
      let rp = this.$route; // route params
      let crd = this.getCurrentRouteDetails(rp.name);

      if (rp.params.resetPage || !crd.routeName) {
        let subTabDetails = {
          page: 1,
          userTypes: [],
          orderBy: {
            field: "created_at",
            order: "DESC",
          },
        };
        let tabDetail = {
          default: subTabDetails,
        };
        let routeDetails = {
          routeName: rp.name,
          selectedTab: "default",
          tabDetails: tabDetail,
        };
        this.setRouteDetails(routeDetails);
      }
      this.defaultData();
    },
    updateReadStatus(item) {
      if (!item.is_read && this.pathName.includes("inbox")) {
        this.$root.showLoader = true;
        let reqData = {
          id: item.id,
        };
        this.updateNotificationReadStatus(reqData)
          .then((response) => {
            item.is_read = 1;
            this.$root.showLoader = false;
          })
          .catch((err) => {
            this.$root.showLoader = false;
          });
      }
      this.renderMath();
    },
    shouldShowBroadcastButton() {
      return [12, 5].includes(this.user.role_id);
    },
    addBoldClass(item) {
      if (!item.is_read && this.pathName.includes("inbox")) {
        return true;
      } else return false;
    },
    showRootLoader(val) {
      this.$root.showLoader = val;
    },
    onClose(data) {
      this.status = data.status;
      if (data.action === "yes" && data.refId === "deleteMessage") {
        this.requestDelteMessage(data.item);
      }
      if (data.realodMessage) {
        this.requestGetMessages();
      }
    },
    getUserName(item) {
      if (this.pathName.includes("inbox")) {
        return item.fromUser ? item.fromUser.username : "";
      } else {
        let to = "";
        if (item.recipients && item.recipients.length) {
          item.recipients.map((r) => {
            if (to) {
              to =
                to +
                "," +
                (r.recipient.username || r.recipient.name || "unknown");
            } else {
              to = r.recipient.username || r.recipient.name || "unknown";
            }
          });
        }
        return to && to.length > 50 ? to.substring(0, 50) + "..." : to;
      }
    },
    getUserRole(item) {
      if (this.pathName.includes("inbox")) {
        return item.fromUser && item.fromUser.role
          ? item.fromUser.role.role_name
          : "";
      } else {
        let roleName = "";
        if (item.recipients && item.recipients.length) {
          item.recipients.map((r) => {
            if (roleName) {
              if (!roleName.includes(r.recipient.role.role_name)) {
                roleName = roleName + "," + r.recipient.role.role_name;
              }
            } else {
              roleName = r.recipient.role ? r.recipient.role.role_name : "";
            }
          });
        }
        return roleName;
      }
    },
    onHeaderAction(e) {
      if (e.data && e.data.selectedItems) {
        this.selectedUsertypes = e.data.selectedItems;
        let routeName = this.$route.name;
        let crd = this.getCurrentRouteDetails(routeName);
        crd.tabDetails[crd.selectedTab].userTypes = e.data.selectedItems;
        this.setRouteDetails(crd);
        this.onPageChange(1);
        // this.requestGetMessages();
      }
    },
    onSortChange() {
      this.requestGetMessages();
    },
    requestGetMessages() {
      let reqData = {
        type: this.pathName.includes("inbox") ? "inbox" : "sent",
        pagination: {
          page: this.currentPage,
          pageSize: this.pageSize,
        },
        orderBy: this.orderBy,
        userTypes: this.selectedUsertypes,
      };
      this.$root.showLoader = true;
      this.getMessages(reqData)
        .then((response) => {
          if (
            response.list.length == 0 &&
            this.currentPage != 1 &&
            !this.$route.query.resetPage
          ) {
            this.onPageChange(1);
            return;
          }
          this.$root.showLoader = false;
          this.items = response.list.map((u) => {
            u.created_at = moment.utc(u.created_at).format("DD MMM YYYY");
            u.subitem = [{ message: u.message }];
            return u;
          });

          this.totalPages = response.pagination.pageCount;
          this.renderMath();
        })
        .catch((err) => {
          this.$root.showLoader = false;
        });
    },
    requestDelteMessage(item) {
      let reqData = {
        id: item.id,
      };
      this.deleteMessage(reqData)
        .then((response) => {
          this.requestGetMessages();
        })
        .catch((err) => {
          this.$root.showLoader = false;
        });
    },

    DeleteMSGDialog(item) {
      this.cComponent = "components/coordinator/ConfirmationDialog";
      this.selectedUser = {
        item,
        message: "Are you sure you want to delete message?",
        refId: "deleteMessage",
      };
      this.modalwidth = "350px";
      this.status = true;
      this.$forceUpdate();
    },
    ComposeMsgDialog(item) {
      if (item) {
        this.selectedUser = [item.fromUser];

        if (this.pathName.includes("inbox")) {
          this.selectedUser = [item.fromUser];
        } else {
          if (item.recipients && item.recipients.length) {
            this.selectedUser = item.recipients.map((r) => {
              return r.recipient;
            });
            //this.selectedUser = [];
          }
        }
      } else {
        this.selectedUser = [];
      }
      this.cComponent = "components/coordinator/ComposeMsg";
      this.modalwidth = "750px";
      this.status = true;
      this.$forceUpdate();
    },
    broadcastMsgComposeDialog() {
      this.cComponent = "components/coordinator/BroadcastMessage";
      this.modalwidth = "750px";
      this.status = true;
      this.$forceUpdate();
    },
    onPageChange(e) {
      this.currentPage = e;
      this.requestGetMessages();
    },
    getUserTypes() {
      return [
        {
          text: "Student",
          value: this.roleIds.ST,
          checked: this.selectedUsertypes.includes(this.roleIds.ST),
        },
        {
          text: "Parent",
          value: this.roleIds.PA,
          checked: this.selectedUsertypes.includes(this.roleIds.PA),
        },
        {
          text: "Coordinator",
          value: this.roleIds.CO,
          checked: this.selectedUsertypes.includes(this.roleIds.CO),
        },
        {
          text: "Institute Director",
          value: this.roleIds.ID,
          checked: this.selectedUsertypes.includes(this.roleIds.ID),
        },
        {
          text: "Teacher",
          value: this.roleIds.TR,
          checked: this.selectedUsertypes.includes(this.roleIds.TR),
        },
      ];
    },
  },
  computed: {
    ...mapState("app", ["selectedMenu", "selectedSubMenu"]),
    ...mapState("userStore", ["user"]),
    headers() {
      return [
        {
          text: "Date",
          value: "created_at",
          class: "text-center fix-101",
        },
        {
          text: this.pathName.includes("inbox") ? "From" : "To",
          value: "users.name",
          class: "text-center fix-101",
        },
        {
          text: "User Type",
          value: "role_name",
          type: "multidropdown",
          options: this.userTypes,
          allText: "All User Types",
        },
        {
          text: "Content",
          value: "message",
          hideSort: true,
          class: "max-250",
        },
        {
          text: "",
          value: "data-table-expand",
          type: "blank",
          class: "action-100",
        },
      ];
    },
  },
  watch: {
    selectedSubMenu(val) {
      this.pathName = window.location.pathname;
      this.selectedUsertypes = [];
      this.items = [];
      this.currentPage = 1;
      this.status = false;
      this.orderBy = {
        field: "created_at",
        order: "DESC",
      };
      this.checkSessionData();
      // this.userTypes = this.getUserTypes();
      // this.currentPage = 1;
      // this.status = false;
      // (this.orderBy = {
      //     field: "created_at",
      //     order: "DESC"
      // }),
      // this.requestGetMessages();
    },
  },
};
</script>
